module.exports = __webpack_public_path__ + "img/justin.f9f4a488.jpg";